import { Stack } from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import { FC } from "react";
import { HOME_SEGMENT_DIMENSIONS } from "./constants";
interface IHomeSegmentTitleProps {
  children: any;
}

const CONTAINER_STYLES = (theme: Theme) => ({
  padding: "8px 12px",
  fontSize: "16px",
  fontWeight: "600",
  height: `${HOME_SEGMENT_DIMENSIONS(theme).TITLE.HEIGHT}px`,
  borderBottom: HOME_SEGMENT_DIMENSIONS(theme).BORDER_BOTTOM,
  "> .MuiSvgIcon-root": {
    marginRight: "8px"
  }
});

const HomeSegmentTitle: FC<IHomeSegmentTitleProps> = (props) => {
  const { children } = props;
  const theme = useTheme();
  return (
    <Stack direction="row" alignItems="center" sx={CONTAINER_STYLES(theme)}>
      {children}
    </Stack>
  );
};

export default HomeSegmentTitle;
